import ExpenseList from "@/components/Expenses/ExpenseList.vue";
import ExpenseEdit from "@/components/Expenses/ExpenseEdit.vue";
import ExpenseFilter from "@/components/Expenses/ExpenseFilter.vue";
import ExpenseHeader from "@/components/Expenses/ExpenseHeader.vue";    

export default [
    {
        path: 'expense',
        alias: 'expenses',
        name: 'All Expenses',
        redirect: "/expense/list",
        components: {
            page: ExpenseList,
            header: ExpenseHeader,
        },
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: "filter",
                name: "Expense Filter",
                components: {
                    modal: ExpenseFilter
                }
            },
            {
                path: "list/:filter?",
                name: "Expense List",
                components: {
                    // ... NONE
                }
            },
            {
                path: "new",
                name: "Expense New",
                components: {
                    modal: ExpenseEdit,
                }
            },
            {
                path: "edit/:id",
                name: "Expense Edit",
                components: {
                    modal: ExpenseEdit,
                }
            }
        ]
    }
];